// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
export const paths: string[] = [
  'M1.75 12H4.5C7 12 9 4 11.5 4H14.25',
  'M1.75 4H4.5C5.31 4 6.06 4.83 6.8 5.96',
  'M9.2 10.04C9.94 11.17 10.69 12 11.5 12H14.25',
  'M12 1.75L14.25 4L12 6.25M12 9.75L14.25 12L12 14.25',
];
